import {
  useQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { menuServices } from 'features/menu/services/menu.service';

/**
 * ----------------------------------------
 * REUSABLE API ERROR PARSER
 * ----------------------------------------
 */

export const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error  ||
      error?.message                 ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * ----------------------------------------
 * GET ALL MENUS
 * ----------------------------------------
 */

export const useMenus = (params) => {
  const query = useQuery({
    queryKey: ['menus', params],

    queryFn: async () => {
      try {
        return await menuServices.getMenus(params);
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime:        5  * 60 * 1000,
    gcTime:           10 * 60 * 1000,
    placeholderData:  (previousData) => previousData,
    retry:            1,
  });

  // Returned as array to preserve existing destructuring:
  // const [{ data, isLoading, isError, error }] = useMenus(filters);
  return [query];
};

/**
 * ----------------------------------------
 * MANAGE MENU ITEM
 * Payload shape:
 * {
 *   menuId:        string   — menu _id
 *   subcategoryId: string   — subcategory ObjectId  ✅ was categoryName
 *   itemSlug:      string
 *   isApproved?:   boolean
 *   isAvailable?:  boolean
 *   images?:       { url, key, isPrimary }[]
 * }
 * ----------------------------------------
 */

export const useManageMenuItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) => {
      try {
        return await menuServices.manageItem(payload);
      } catch (error) {
        throw parseApiError(error);
      }
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['menus'],
      });
    },
  });
};